import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'clientInvoices';
let loaded = loadState(STORE_KEY) || [];

const state = {
	clientInvoices: loaded.clientInvoices || [],
	invoiceDetails: loaded.invoiceDetails || {},
	clientWallet: loaded.clientWallet || [],
	clientTransactions: loaded.clientTransactions || [],
};

const mutations = {
	SET_INVOICES_DATA(state, invoices) {
		state.clientInvoices = invoices;
		saveState(STORE_KEY, state);
	},
	SET_INVOICE_DETAILS(state, invoice) {
		state.invoiceDetails = invoice;
		saveState(STORE_KEY, state);
	},
	SET_CLIENT_WALLET(state, wallet) {
		state.clientWallet = wallet;
		saveState(STORE_KEY, state);
	},
	SET_CLIENT_TRANSACTIONS(state, transactions) {
		state.clientTransactions = transactions;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setClientInvoicesData({ commit }, data) {
		commit('SET_INVOICES_DATA', data);
	},
	setInvoiceDetails({ commit }, data) {
		commit('SET_INVOICE_DETAILS', data);
	},
	setClientWallet({ commit }, data) {
		commit('SET_CLIENT_WALLET', data);
	},
	setClientTransactions({ commit }, data) {
		commit('SET_CLIENT_TRANSACTIONS', data);
	},
};

const getters = {
	selectInvoicesData: (state) => state.clientInvoices,
	selectInvoiceDetails: (state) => state.invoiceDetails,
	selectClientWallet: (state) => state.clientWallet,
	selectClientTransactions: (state) => state.clientTransactions,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
